import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { getBaseDomain } from "@eyeo/webext-ad-filtering-solution/adblockpluscore/lib/url";
import { Prefs } from "~/alias/prefs";
export async function getMatchingDomain(domain) {
    if (!domain) {
        return null;
    }
    const domains = await ewe.experiments.getFlag("pageview-metrics:domains");
    if (!isStringArray(domains) || !domains.length) {
        return null;
    }
    const baseDomain = getBaseDomain(domain);
    if (!domains.includes(baseDomain)) {
        return null;
    }
    return baseDomain;
}
export async function hasUbo() {
    await Prefs.untilLoaded;
    return Date.now() - Prefs.get("uboDetected") < 7 * 24 * 60 * 60 * 1000;
}
export async function uboDetectionWasActive() {
    await Prefs.untilLoaded;
    return Date.now() - Prefs.get("uboDetectionLastRun") < 7 * 24 * 60 * 60 * 1000;
}
function isStringArray(candidate) {
    return Array.isArray(candidate) && (!candidate.length || typeof candidate[0] === "string");
}
